import { cancellableRequest } from './request';

const PackagesService = {
    getServicePackage: (booking) =>
        cancellableRequest({ method: 'post', url: '/service-calculated-package', data: booking }),
};

export { PackagesService };
